import { HttpHeaders, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { DataPersistenceService } from '../services/data-persistence/data-persistence.service';

export const TOKEN_PERMISOS_HEADER = 'X-Token-Permisos';

/** Solo el BFF de Registro recibe el tokenPermisos: no se envía a otros hosts (SSO, microfrontends, terceros). */
export function esUrlBff(url: string): boolean {
  const base = (environment.urlApi || '').replace(/\/+$/, '');
  return !!base && (url === base || url.startsWith(`${base}/`));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const dataPersistenceService = inject(DataPersistenceService);
  const authService = inject(AuthService);

  // No agregar token para URLs de formulario externo (registro público de proveedores)
  if (req.url.includes('/external-form/')) {
    return next(req);
  }

  if (req.url.includes('refrescartoken')) {
    return next(req);
  }

  const accessToken = dataPersistenceService.getAccessToken();
  if (!accessToken) {
    return next(req);
  }

  const conCredenciales = (headers: HttpHeaders, token: string | null): HttpHeaders => {
    let h = headers.set('Authorization', `Bearer ${token}`);
    // Login por email: el BFF resuelve usuario/empresa desde el tokenPermisos (el username de Cognito es el email).
    const tokenPermisos = esUrlBff(req.url) && !h.has(TOKEN_PERMISOS_HEADER) ? dataPersistenceService.getTokenPermisos() : '';
    if (tokenPermisos) {
      h = h.set(TOKEN_PERMISOS_HEADER, tokenPermisos);
    }
    return h;
  };

  const authReq = req.clone({ headers: conCredenciales(req.headers, accessToken) });

  return next(authReq).pipe(
    catchError((err) => {
      if (err.status === HttpStatusCode.Unauthorized) {
        return authService.refreshToken().pipe(
          switchMap(() => {
            const newReq = req.clone({
              headers: conCredenciales(req.headers, dataPersistenceService.getAccessToken()).set('X-Skip-Snackbar', 'true'),
            });

            return next(newReq);
          }),
          catchError((refreshError) => {
            authService.logout();
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => err);
    })
  );
};
